import type { Commands } from '../../../messageHandler';
import { getSandbox } from '../../browser';
import UrlService from '../../UrlService';

const handleIframeLoad = (commands: Commands, url: URL | undefined): void => {
  if (!UrlService.isGoogleLocalDevUrl(url)) {
    return;
  }

  if (getSandbox() !== 'local') {
    window.parent.postMessage({ message: 'set sandbox', sandbox: 'local' }, '*');
  }

  window.parent.postMessage({ message: 'open' }, '*');
  commands.setHomePage();
};

const handleDataChange = (commands: Commands): void => {
  commands.setCompanyPage({ companyDomain: 'google.com' });
};

export const googleMessageHandler = {
  handleIframeLoad,
  handleDataChange,
};
